import React from "react";
import { Page, Text, View, Document } from '@react-pdf/renderer';

import { isoDateToHumanDate, stringDivider } from "../../utils/globalFunctions";

const PrintLabel = ({ stateData }) => {

  return (
    <Document>
      <Page size={164}>
        {Array.isArray(stateData.kelengkapan) &&
          <View
            style={{
              padding: '2px 2px 0px 2px',
              fontSize: '10px',
              marginBottom: stateData.kelengkapan.length === 0 ? '0px' : '2px'
            }}
          >
            <Text
              style={{
                marginBottom: '4px',
                padding: '2px',
                backgroundColor: '#000',
                color: '#fff',
                fontSize: '11px'
              }}
            >
              {stateData.customer ? stateData.customer : ' - '}
            </Text>

            <View
              style={{
                display: 'flex',
                flexDirection: "row",
                flexWrap: "nowrap",
                marginBottom: '4px',
                paddingLeft: '2px',
                paddingRight: '2px',
              }}
            >
              <Text
                style={{
                  flexBasis: 'auto',
                  flexGrow: '1',
                }}
              >
                {stateData.projectId ? stringDivider(stateData.projectId, [4, 6, 8], '.', ' - ') : ' - '}
              </Text>

              <View
                style={{
                  flexBasis: 'auto',
                  flexGrow: '1',
                  alignItems: 'flex-end',
                }}
              >
                <Text>
                  {isoDateToHumanDate({
                    stateDate: stateData.tanggalMasuk,
                    stateLang: 'id',
                    stateIsShort: true,
                    stateDay: false,
                    stateDefaultValue: ' - ',
                    stateDateType: 'day'
                  })}
                </Text>
              </View>
            </View>

            <Text
              style={{
                marginBottom: '4px',
                paddingLeft: '2px',
                paddingRight: '2px',
              }}
            >
              <Text>
                {stateData.barangNama ? `${stateData.barangNama}${Array.isArray(stateData.kelengkapan) && (stateData.kelengkapan.length > 0) ? ', ' : ''}` : ' - '}
              </Text>

              {Array.isArray(stateData.kelengkapan) && (stateData.kelengkapan.length > 0) && Object.keys(stateData.kelengkapan).map((subKeyLbl) => {
                return (
                  <Text key={subKeyLbl}>
                    {stateData.kelengkapan[subKeyLbl].kelengkapan_barang_nama + (stateData.kelengkapan.length === (Number(subKeyLbl) + 1) ? '' : ', ')}
                  </Text>
                )
              })}

              <Text>{` (${stateData.barangNama ? 1 : 0}/${(stateData.barangNama ? 1 : 0) + stateData.kelengkapan.length})`}</Text>
            </Text>

            <Text
              style={{
                marginBottom: '2px',
                paddingBottom: '4px',
                paddingLeft: '2px',
                paddingRight: '2px',
                borderBottom: '1px solid #000',
              }}
            >
              {stateData.kerusakan ? stateData.kerusakan : ' - '}
            </Text>

            {Array.isArray(stateData.kelengkapan) && (stateData.kelengkapan.length > 0) && Object.keys(stateData.kelengkapan).map((keyIndukLbl) => {
              return (
                <View
                  key={keyIndukLbl}
                  style={{
                    borderBottom: '1px solid #000',
                    padding: '2px 2px 4px 2px',
                    fontSize: '10px',
                    marginBottom: stateData.kelengkapan.length === (Number(keyIndukLbl) + 1) ? '0px' : '2px'
                  }}
                >
                  <View>
                    <Text style={{ marginBottom: '4px', fontSize: '11px' }}>
                      {stateData.customer ? stateData.customer : ' - '}
                    </Text>

                    <Text style={{ marginBottom: '4px' }}>
                      {stateData.kelengkapan[keyIndukLbl].project_id ? stringDivider(stateData.kelengkapan[keyIndukLbl].project_id, [4, 6, 8], '.', ' - ') : ' - '}
                    </Text>

                    <Text>
                      <Text>
                        {stateData.barangNama ? `${stateData.barangNama}${Array.isArray(stateData.kelengkapan) && (stateData.kelengkapan.length > 0) ? ', ' : ''}` : ' - '}
                      </Text>

                      {Array.isArray(stateData.kelengkapan) && (stateData.kelengkapan.length > 0) && Object.keys(stateData.kelengkapan).map((subKeyLbl) => {
                        return (
                          <Text key={subKeyLbl}>
                            {stateData.kelengkapan[subKeyLbl].kelengkapan_barang_nama + (stateData.kelengkapan.length === (Number(subKeyLbl) + 1) ? '' : ', ')}
                          </Text>
                        )
                      })}

                      <Text>{` (${Number(keyIndukLbl) + 2}/${stateData.kelengkapan.length + (stateData.barangNama ? 1 : 0)})`}</Text>
                    </Text>
                  </View>
                </View>
              )
            })}

            {stateData.kelengkapan.length <= 1 &&
              <View style={{ height: '50px' }}>
                <Text>&nbsp;</Text>
              </View>
            }
          </View>
        }
      </Page>
    </Document>
  )
}

export default React.memo(PrintLabel);